import { render } from "./HeaderModal.vue?vue&type=template&id=71a593e0&scoped=true"
import script from "./HeaderModal.vue?vue&type=script&lang=js"
export * from "./HeaderModal.vue?vue&type=script&lang=js"

import "@/assets/css/newdesign.scss?vue&type=style&index=0&id=71a593e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a593e0"]])

export default __exports__